/*
 * @Description:
 * @Date: 2023/4/19 上午11:43:11
 */
export const route = [
  /** 项目详情入口：req-left 跳转，无 parentPath，走项目原逻辑 */
  {
    path: '/main/form-add-list',
    name: 'form-add-list',
    meta: {
      title: '表单',
      isMenuSkip: true
    },
    component: () => import('../views/form-add-list.vue')
  },
  /** 表单管理入口：form-manage 列表跳转，面包屑指向 form-manage-list */
  {
    path: '/main/form-add-list-edit',
    name: 'form-add-list-edit',
    meta: {
      title: '表单',
      parentPath: '/main/form-manage-list'
    },
    component: () => import('../views/form-add-list.vue')
  }
];
